import { useSyncExternalStore, useRef, useCallback } from 'react';
export default function useObserveResize(ref) {
  const sizeRef = useRef({
    width: 0,
    height: 0
  });
  const subscribe = useCallback(callback => {
    if (!ref.current) return () => {};
    const observer = new ResizeObserver(entries => {
      if (entries[0]) {
        const {
          width,
          height
        } = entries[0].contentRect;
        sizeRef.current = {
          width,
          height
        };
        callback();
      }
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);
  const getSnapshot = useCallback(() => sizeRef.current, []);
  return useSyncExternalStore(subscribe, getSnapshot);
}